export default "/images/storstroems_forsikring.svg?614c101eba4c74de66a2720bbd5863f5";